import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { SovereignFlame, Portrait } from './SovereignFlame';

/* Full-screen sealing ceremony: wax slam → gold shockwave → vow engraves letter by letter. */
export const OathCeremony = ({ text, realm, user, onDone }) => {
  useEffect(() => { const t = setTimeout(onDone, 5200); return () => clearTimeout(t); }, [onDone]);
  const words = text.split(' ');
  return (
    <motion.div className="fixed inset-0 z-[300] flex flex-col items-center justify-center px-8 text-center" onClick={onDone}
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="oath-ceremony"
      style={{ background: 'radial-gradient(circle at 50% 40%, rgba(58,15,94,0.95), #030306 70%)' }}>
      {[0, 1, 2].map((i) => (
        <motion.div key={i} className="absolute rounded-full pointer-events-none" style={{ width: 200, height: 200, top: '22%', background: 'radial-gradient(circle, rgba(255,233,160,0.35), rgba(212,175,55,0.12) 45%, transparent 70%)' }}
          initial={{ scale: 0.4, opacity: 0 }} animate={{ scale: 3.2, opacity: [0, 0.7, 0] }} transition={{ delay: 0.55 + i * 0.25, duration: 1.6, ease: 'easeOut' }} />
      ))}
      <motion.div className="relative" initial={{ scale: 2.6, y: -160, opacity: 0 }} animate={{ scale: 1, y: 0, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 260, damping: 15, mass: 1.1 }}>
        <SovereignFlame size={170}><Portrait user={user} /></SovereignFlame>
      </motion.div>
      <motion.p className="font-['Outfit'] text-[10px] tracking-[0.45em] uppercase mt-8" style={{ color: '#D4AF37' }}
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1 }}>Sealed in gold · {realm?.label || 'Sovereign'}</motion.p>
      <p className="font-['Cormorant_Garamond'] italic text-3xl text-white mt-4 leading-snug max-w-sm [overflow-wrap:anywhere]">
        {words.map((w, i) => (
          <motion.span key={i} className="inline-block mr-2" initial={{ opacity: 0, y: 8, filter: 'blur(6px)' }} animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
            transition={{ delay: 1.2 + i * 0.14 }}>{w}</motion.span>
        ))}
      </p>
      <motion.p className="font-['Cinzel'] text-lg mt-10" style={{ color: '#FFE9A0', textShadow: '0 0 20px rgba(212,175,55,0.7)' }}
        initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 1.6 + words.length * 0.14 }}>
        You are a person of your word.
      </motion.p>
      <motion.p className="font-['Outfit'] text-xs text-white/40 mt-3" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 2.4 + words.length * 0.14 }}>
        Return tonight to confirm you kept it.
      </motion.p>
    </motion.div>
  );
};

export default OathCeremony;
